// Custom namespace UUID (generate once, reuse for consistency)
// You can generate your own at https://www.uuidgenerator.net/ or use v5.URL/v5.DNS
const MY_NAMESPACE = "ae9bdb2c-45ef-4d2d-957a-ee7f95ba3dc4";

// To decrypt (same function works!)
// Note: For decryption, pass the base64-decoded bytes as a stringified blob
export function simpleDecryptJson(encryptedStr: string, key: string = MY_NAMESPACE): unknown {
  // Base64 decode
  const encryptedBytesStr = atob(encryptedStr);
  const encryptedBytes: Uint8Array = new Uint8Array(encryptedBytesStr.length);
  for (let i = 0; i < encryptedBytesStr.length; i++) {
    encryptedBytes[i] = encryptedBytesStr.charCodeAt(i);
  }

  // XOR again to decrypt (same as encrypt)
  const keyBytes: Uint8Array = new TextEncoder().encode(key);
  const decryptedBytes: Uint8Array = new Uint8Array(encryptedBytes.length);
  for (let i = 0; i < encryptedBytes.length; i++) {
    const keyByte: number = keyBytes[i % keyBytes.length];
    decryptedBytes[i] = encryptedBytes[i] ^ keyByte;
  }

  const decryptedStr: string = new TextDecoder().decode(decryptedBytes);
  return JSON.parse(decryptedStr);
}

export function simpleEncryptJson(obj: unknown, key: string = MY_NAMESPACE): string {
  // Convert JSON to string
  const jsonStr: string = JSON.stringify(obj);

  // XOR each byte with the key (cycle through key bytes)
  const keyBytes: Uint8Array = new TextEncoder().encode(key);
  const jsonBytes: Uint8Array = new TextEncoder().encode(jsonStr);
  const encryptedBytes: Uint8Array = new Uint8Array(jsonBytes.length);

  for (let i = 0; i < jsonBytes.length; i++) {
    const keyByte: number = keyBytes[i % keyBytes.length];
    encryptedBytes[i] = jsonBytes[i] ^ keyByte;
  }

  // Base64 encode for safe output
  return btoa(String.fromCharCode(...encryptedBytes));
}
